import Footer from './Footer';
import { connect } from './connect';

export default connect(Footer);
